import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
} from '@angular/core';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import SwiperCore, { Navigation, Pagination, EffectCreative } from 'swiper';
SwiperCore.use([Navigation, Pagination, EffectCreative]);

@Component({
  selector: 'app-section-features',
  templateUrl: './section-features.component.html',
  styleUrls: ['./section-features.component.scss'],
})
export class SectionFeaturesComponent implements OnInit, AfterViewInit {
  faAngleRight = icon(faAngleRight).html;
  faAngleLeft = icon(faAngleLeft).html;

  constructor(private renderer: Renderer2, private el: ElementRef) {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    const $prevBtn = this.el.nativeElement.querySelector(
      '.swiper .swiper-button-prev'
    );
    const $nextBtn = this.el.nativeElement.querySelector(
      '.swiper .swiper-button-next'
    );

    if ($prevBtn) {
      this.renderer.setProperty($prevBtn, 'innerHTML', this.faAngleLeft);
    }
    if ($nextBtn) {
      this.renderer.setProperty($nextBtn, 'innerHTML', this.faAngleRight);
    }
  }
}
